// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_goliaths_plus_main_div {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}



.user_goliaths_plus_title {
    margin: 0 0 16px 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_goliaths_plus_item_desc {
    margin: 0;
    /* margin: 5px 0; */
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.user_goliaths_plus_label {
    margin: 0;
    font-size: 13px;
    color: var(--text-muted);
}

.user_goliaths_plus_column {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.user_goliaths_plus_actions_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid var(--border);
}

.user_goliaths_plus_offer_subscription_group {
    display: flex;
    align-items: center;
    gap: 12px;
}

.user_goliaths_plus_offer_subscription_label {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-muted);
}

.user_goliaths_plus_offer_subscription_control {
    display: flex;
    align-items: stretch;
}

.user_goliaths_plus_months_select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: var(--bg-card);
    color: var(--text-primary);
    border: 1px solid var(--primary);
    border-right: none;
    padding: 0 12px;
    border-radius: var(--radius-sm) 0 0 var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    outline: none;
}

.user_goliaths_plus_months_select:hover {
    background-color: var(--primary-50);
}

.user_goliaths_plus_offer_subscription_button {
    background-color: var(--primary);
    padding: 8px 18px;
    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    transition: all var(--transition-fast);
    white-space: nowrap;
}

.user_goliaths_plus_offer_subscription_button:hover {
    filter: brightness(1.08);
}

.user_goliaths_plus_cancel_subscription_button {
    background-color: transparent;
    padding: 8px 18px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--primary);
    outline: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: var(--primary);
    transition: all var(--transition-fast);
}

.user_goliaths_plus_cancel_subscription_button:hover:not(:disabled) {
    background-color: var(--primary-50);
}

.user_goliaths_plus_cancel_subscription_button:disabled {
    border-color: var(--border);
    color: var(--text-muted);
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserGoliathsPlus/userGoliathsPlus.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;;;AAIA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,gCAAgC;IAChC,0BAA0B;IAC1B,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,oDAAoD;IACpD,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,oDAAoD;IACpD,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,mBAAmB;AACvB","sourcesContent":[".user_goliaths_plus_main_div {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    gap: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n\n\n.user_goliaths_plus_title {\n    margin: 0 0 16px 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_goliaths_plus_item_desc {\n    margin: 0;\n    /* margin: 5px 0; */\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.user_goliaths_plus_label {\n    margin: 0;\n    font-size: 13px;\n    color: var(--text-muted);\n}\n\n.user_goliaths_plus_column {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.user_goliaths_plus_actions_box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border);\n}\n\n.user_goliaths_plus_offer_subscription_group {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.user_goliaths_plus_offer_subscription_label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--text-muted);\n}\n\n.user_goliaths_plus_offer_subscription_control {\n    display: flex;\n    align-items: stretch;\n}\n\n.user_goliaths_plus_months_select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    border: 1px solid var(--primary);\n    border-right: none;\n    padding: 0 12px;\n    border-radius: var(--radius-sm) 0 0 var(--radius-sm);\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    outline: none;\n}\n\n.user_goliaths_plus_months_select:hover {\n    background-color: var(--primary-50);\n}\n\n.user_goliaths_plus_offer_subscription_button {\n    background-color: var(--primary);\n    padding: 8px 18px;\n    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: #fff;\n    transition: all var(--transition-fast);\n    white-space: nowrap;\n}\n\n.user_goliaths_plus_offer_subscription_button:hover {\n    filter: brightness(1.08);\n}\n\n.user_goliaths_plus_cancel_subscription_button {\n    background-color: transparent;\n    padding: 8px 18px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--primary);\n    outline: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--primary);\n    transition: all var(--transition-fast);\n}\n\n.user_goliaths_plus_cancel_subscription_button:hover:not(:disabled) {\n    background-color: var(--primary-50);\n}\n\n.user_goliaths_plus_cancel_subscription_button:disabled {\n    border-color: var(--border);\n    color: var(--text-muted);\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
